import React from 'react';
import Header from '../components/Header/Header';
import Service_Page from '../components/Service_Page/Service_Page';
import CTABanner from '../components/CTABanner/CTABanner';
import useServices from '../hooks/useServices';
import './Services.css';

const Services = () => {
  const { services, loading } = useServices();

  return (
    <div className="page-wrapper">
      <div className="hero-wrapper">
        <Header />
        <div className="page-hero">
          <div className="page-hero-overlay"></div>
          <div className="page-hero-content">
            <h1>Our Services</h1>
            <p className="hero-description">Comprehensive electrical solutions for your home and business</p>
            <div className="breadcrumb">
              <a href="/">Home</a>
              <span className="separator">/</span>
              <span className="active">Services</span>
            </div>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="services-loading"><p>Loading services...</p></div>
      ) : (
        <Service_Page services={services} />
      )}

      <CTABanner />
    </div>
  );
};

export default Services;
